export interface SerieListItem {
  idTalonarioComprobante: number;
  idTalonario: number;
  idComprobante: number;
  serie: string;
  proximoNumero: number;
  comprobante: string;
  esPrincipal: boolean;
}

export interface SerieRequest {
  idComprobante: number;
  serie: string;
  proximoNumero: number;
  esPrincipal: boolean;
}

export const initialSerieRequest: SerieRequest = {
  idComprobante: 0,
  serie: '',
  proximoNumero: 1,
  esPrincipal: true,
};

export interface ComprobanteOption {
  idComprobante: number;
  nombre: string;
}

export const COMPROBANTES_VENTA: ComprobanteOption[] = [
  { idComprobante: 29, nombre: 'Boleta de Venta' },
  { idComprobante: 12, nombre: 'Factura' },
  { idComprobante: 30, nombre: 'Nota de Venta' },
];
